// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TUswFVyPViYt1JGc{height:100%;width:100%;display:flex;flex-direction:column;justify-content:flex-start;align-items:center;padding-top:16px}.TUswFVyPViYt1JGc .vVtaWYHnOMITfp7Y{height:256px;width:calc(100% - 25px)}.TUswFVyPViYt1JGc .ZnhvOzDjbc3XpLv7{height:100%;display:flex;justify-content:center;align-items:center}.TUswFVyPViYt1JGc .CmY6xZ2vNm0GwUV6{position:absolute;display:flex;justify-content:center;height:100%;width:100%;align-items:center}.TUswFVyPViYt1JGc .CmY6xZ2vNm0GwUV6 .Nuu3A01SnAAcFydG{width:234px;text-align:center;z-index:1}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cardBody": `TUswFVyPViYt1JGc`,
	"cohortsChart": `vVtaWYHnOMITfp7Y`,
	"spinnerBox": `ZnhvOzDjbc3XpLv7`,
	"noDataMessage": `CmY6xZ2vNm0GwUV6`,
	"noMessageText": `Nuu3A01SnAAcFydG`
};
export default ___CSS_LOADER_EXPORT___;
